import angular = require('angular');

export class FaltastrabalhadoresService {

    static $inject = ['$http', 'nsjRouting', '$rootScope', '$q'];

    public entity: any = [];
    public entities: any = [];
    public loaded: boolean = false;
    public constructors: any = {};
    public after: any = {};
    public filters: any = {};
    public loadParams: any = {
        to_load: 3,
        busy: false,
        finished: false,
    };
    public loading_deferred: any = null;
    public filter: any = '';

    constructor(public $http: any, public nsjRouting: any, public $rootScope: any, public $q: any) { }

    reload() {
        if (this. loading_deferred) {
            this. loading_deferred.resolve();
        }

        this. loadParams.finished = false;
        this. loadParams.to_load = 3;
        this. after = {};
        this. loaded = false;
        this. entities.length = 0;
        this. loadParams.busy = false;

        return this.load();
    }

    search(filter: any) {
        if (typeof filter !== 'undefined') {
            this. filter = filter.search;
            Object.keys(this. filters).forEach((k: any) => { delete this. filters[k]; });
            for (var fil in filter.filters) {
                if (fil.indexOf('.') > -1) {
                    var filterSplit = fil.split('.');
                    this. filters[filterSplit[0]] = {};
                    this. filters[filterSplit[0]][filterSplit[1]] = filter.filters[fil];
                } else {
                    this. filters[fil] = filter.filters[fil];
                }
            }
        }

        return this. reload();
    }

    _load(constructors: any, offset: any, filter: any) {
        this. loading_deferred = this.$q.defer();

        return this.$q((resolve: any, reject: any) => {
            this.$http({
                    method: 'GET',
                    url: this.nsjRouting.generate('faltastrabalhadores_index', angular.extend({}, constructors, { 'offset': offset, 'filter': filter }, this. filters), true),
                    timeout: this. loading_deferred.promise
                })
                .then((response: any) => {
                    resolve(response.data);
                })
                .catch((response: any) => {
                    reject(response);
                });

        });

    }

    load() {
        if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
            this.loadParams.busy = true;

            this._load(this.constructors, this.after, this.filter)
                .then((data: any) => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            this.entities.push(data[i]);
                        }
                        this.after['data'] = this.entities[this.entities.length - 1]['data'];
                        this.after['faltatrabalhador'] = this.entities[this.entities.length - 1]['faltatrabalhador'];
                    }
                    if (data.length < 20) {
                        this.loadParams.finished = true;
                        this.$rootScope.$broadcast('faltastrabalhadores_list_finished', this.entities);
                    } else {
                        this.loadParams.finished = false;
                    }
                    this.loaded = true;

                    this.loadParams.to_load--;
                })
                .catch((error: any) => {
                    if (error.xhrStatus !== 'abort') {
                        this.loadParams.finished = true;
                    }
                })
                .finally(() => {
                    if (this.loaded || this.loadParams.finished) {
                        this.loadParams.busy = false;
                    }
                    this.load();
                });
        }

        return this.entities;
    }

    loadMore() {
        this.loadParams.to_load = 3;
        this.load();
    }

    find(identifier: any) {
        for (var i in this.entities) {
            if (this.entities[i]['faltatrabalhador'] === identifier) {
                return this.entities[i];
            }
        }
        return null;
    }

    delete($identifier: any, force: any) {
        if (typeof($identifier) === 'object') {
            $identifier = $identifier['faltatrabalhador'];
        }
        if ($identifier) {
            if (force || confirm('Tem certeza que deseja deletar?')) {
                this.loading_deferred = this.$q.defer();
                this.$http
                    .delete(this.nsjRouting.generate('faltastrabalhadores_delete', angular.extend(this.constructors, { 'id': $identifier }), true), { timeout: this.loading_deferred.promise })
                    .then((response: any) => {
                        this.$rootScope.$broadcast('faltastrabalhadores_deleted', {
                            entity: this.entity,
                            response: response
                        });
                    })
                    .catch((response: any) => {
                        this.$rootScope.$broadcast('faltastrabalhadores_delete_error', {
                            entity: this.entity,
                            response: response
                        });
                    });
            }
        }
    }

    _save(entity: any, autosave: any) {
        var method, url;
        if (entity['faltatrabalhador']) {
            method = 'PUT';
            url = this.nsjRouting.generate('faltastrabalhadores_put', { trabalhador: entity.trabalhador.trabalhador, 'id': entity['faltatrabalhador'] }, true);
        } else {
            method = 'POST';
            url = this.nsjRouting.generate('faltastrabalhadores_create', angular.extend(this.constructors), true);
        }
        if (!autosave) {
            autosave = false;
            entity['$$__submitting'] = true;
        }
        var data = angular.copy(entity);
        if (data.hasOwnProperty('$$__submitting')) {
            delete data['$$__submitting'];
        }
        this.loading_deferred = this.$q.defer();
        return this.$http({
                method: method,
                url: url,
                data: data,
                timeout: this.loading_deferred.promise
            })
            .finally((response: any) => {
                if (!autosave) {
                    entity['$$__submitting'] = false;
                }
            });
    }

    save(entity: any, autosave: any) {

        this._save(entity, autosave)
            .then((response: any) => {
                if (response.data.faltatrabalhador) {
                    entity['faltatrabalhador'] = response.data.faltatrabalhador;
                }
                entity['$$_saved'] = true;
                this.$rootScope.$broadcast('faltastrabalhadores_submitted', {
                    entity: entity,
                    response: response,
                    autosave: autosave
                });
            })
            .catch((response: any) => {
                this.$rootScope.$broadcast('faltastrabalhadores_submit_error', {
                    entity: entity,
                    response: response,
                    autosave: autosave
                });
            });
    }

    get(trabalhador: any, identifier: any) {
        this.loading_deferred = this.$q.defer();

        return this.$q((resolve: any, reject: any) => {
            this.$http
                .get(this.nsjRouting.generate('faltastrabalhadores_get', { 'trabalhador': trabalhador, 'id': identifier }, true), { timeout: this.loading_deferred.promise })
                .then((response: any) => {
                    this.$rootScope.$broadcast('faltastrabalhadores_loaded', response.data);
                    resolve(response.data);
                })
                .catch((response: any) => {
                    reject(response);
                });
        });
    }
}

angular.module('main').service('FaltastrabalhadoresService', FaltastrabalhadoresService);
